import { render, staticRenderFns } from "./analysisEdu.vue?vue&type=template&id=7e48d2d7&scoped=true&"
import script from "./analysisEdu.vue?vue&type=script&lang=js&"
export * from "./analysisEdu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e48d2d7",
  null
  
)

export default component.exports